<script lang="ts">
    import Modal from '$components/Modal.svelte';
    import { createDialog } from '@melt-ui/svelte';
    import { melt } from '@melt-ui/svelte';
    import logo_webp from '$assets/logo.webp';
    import logo_png from '$assets/logo.png';
    import Picture from '$components/Picture.svelte';
    import GoafricaContactForm from '$components/GoafricaContact/GoafricaContactForm.svelte';
    import {
        type Fields,
        type FormData,
    } from '$components/GoafricaContact/GoafricaContactFormData';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { OnSubmitSuccessParams } from '$components/Form/HtmlForm.svelte';
    import type { CurrentUser_MeFragment } from '$gql/graphql';

    export let form: Form<FormData, string>;
    export let fields: Fields<FormData>;
    export let prefixId: string;
    export let withCompanyNameRequired: boolean = false;
    export let withPhoneRequired: boolean = false;
    export let currentUser: CurrentUser_MeFragment | null;
    export let modalTitle: string | null = null;
    export let messagePlaceholder: string | null = null;
    export let messageLabel: string | null = null;

    export let onSuccess: (params: OnSubmitSuccessParams<FormData, number>) => void;
    export let modal: ReturnType<typeof createDialog>;
    $: close = modal.elements.close;
    $: title = modal.elements.title;
</script>

<Modal contentClass="w-full t:w-[650px]" dialogClass="b:text-left b:items-start" {modal}>
    <div
        class="bg-brand-blue w-full h-[70px] t:h-[90px] flex justify-center relative p-[15px]"
    >
        <Picture
            webp={logo_webp}
            png={logo_png}
            alt="Logo de Go Africa Online"
            class="h-full w-auto"
        />

        <button
            use:melt={$close}
            type="button"
            class="absolute btn-reset top-[15px] right-[20px] text-22 opacity-100 hover:opacity-50"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="p-[15px]">
        {#if modalTitle != null}
            <p use:melt={$title} class="font-bold text-22 text-brand-blue text-center">
                {modalTitle}
            </p>
        {/if}

        <GoafricaContactForm
            {form}
            {fields}
            {prefixId}
            {withCompanyNameRequired}
            {withPhoneRequired}
            {currentUser}
            {messagePlaceholder}
            {messageLabel}
            {onSuccess}
        />
    </div>
</Modal>
